
import React, { FC } from 'react';
import { Button } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import type { UserRow } from '../types/UserTable.types';
import { getUserActionFlags } from '../utils/userTable.utils';
import BaseEllipsisMenu from 'components/BaseEllipsisMenu/BaseEllipsisMenu';

const UserActionsCell: FC<{
  user: UserRow;
  perms?: any;
  /** The currently logged-in user's username/email — used to block self-editing. */
  currentUsername?: string;
  onView?: (id: string | number) => void;
  onEdit?: (id: string | number) => void;
  onDelete?: (user: UserRow) => void;
}> = ({ user, perms, currentUsername, onView, onEdit, onDelete }) => {
  const userId = user.userId;

  const { showViewOnly, canEdit, canDelete } = getUserActionFlags(user, perms, currentUsername);

  const hasViewPermission = Boolean(perms?.testPermission?.([8, 10, 11, 12, 13], ['ViewUsers']));
  const showEye = Boolean(onView) && showViewOnly && hasViewPermission;
  const showEdit = Boolean(onEdit) && canEdit;
  const showDelete = Boolean(onDelete) && canDelete;

  const dropdownOptions = [
    // Include View inside the ellipsis when the standalone eye is not shown
    ...(!showEye && Boolean(onView) && hasViewPermission
      ? [
          {
            component: (
              <Button
                className="w-100 px-5 text-center cursor-pointer text-white border border-1 border-black"
                onClick={() => onView?.(userId)}
                variant="primary"
              >
                View
              </Button>
            ),
          },
        ]
      : []),
    ...(showEdit
      ? [
          {
            component: (
              <Button
                className="w-100 px-5 text-center cursor-pointer text-white border border-1 border-black"
                onClick={() => onEdit?.(userId)}
                variant="primary"
              >
                Edit
              </Button>
            ),
          },
        ]
      : []),
    ...(showDelete
      ? [
          {
            component: (
              <Button
                className="w-100 px-5 text-center cursor-pointer text-white border border-1 border-black"
                onClick={() => onDelete?.(user)}
                variant="danger"
              >
                Remove
              </Button>
            ),
          },
        ]
      : []),
  ];

  return (
    <div key={userId} className="py-2 text-white d-flex align-items-center gap-2">
      {showEye && (
        <Button
          className="rounded-circle py-1 px-2"
          variant="primary"
          onClick={() => onView?.(userId)}
        >
          <FaEye color="white" />
        </Button>
      )}

      {!showEye && dropdownOptions.length > 0 && (
        <BaseEllipsisMenu
          options={dropdownOptions}
          open={false}
          onOpen={() => {}}
          onClose={() => {}}
          closeOnScroll={true}
        />
      )}
    </div>
  );
};

export default UserActionsCell;
